import { type FC, useMemo } from 'react';
import type { AdvancedFilters } from './AdvancedFilterBar';

interface FilterBadgeProps {
  advancedFilters?: AdvancedFilters;
  onReset?: () => void;
}

const FilterBadge: FC<FilterBadgeProps> = ({ advancedFilters, onReset }) => {
  const count = useMemo(() => {
    if (!advancedFilters) return 0;
    return (
      advancedFilters.numberRanges.length +
      advancedFilters.dayOfWeeks.length +
      (advancedFilters.prizeRange ? 1 : 0)
    );
  }, [advancedFilters]);

  if (count === 0) return null;

  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-accent-50 border border-accent-200/70 text-accent-700 text-[11px] font-semibold whitespace-nowrap">
      <span className="w-1 h-1 rounded-full bg-accent-400 animate-[highlightPulseAccent_2s_ease-in-out_infinite]"></span>
      현재 {count}개 필터 적용 중
      {onReset && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onReset();
          }}
          className="ml-0.5 w-4 h-4 flex items-center justify-center rounded-full hover:bg-accent-200/70 transition-colors cursor-pointer"
          aria-label="필터 초기화"
          title="필터 초기화"
        >
          <i className="ri-close-circle-fill text-[12px]"></i>
        </button>
      )}
    </span>
  );
};

export const EmptyFilterState: FC = () => (
  <div className="text-center py-12">
    <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-background-200/50 flex items-center justify-center">
      <i className="ri-search-line text-foreground-300 text-xl"></i>
    </div>
    <p className="text-foreground-500 text-sm font-medium">조건에 맞는 데이터가 없습니다</p>
    <p className="text-foreground-300 text-xs mt-1">필터 조건을 변경하거나 초기화해보세요.</p>
  </div>
);

export default FilterBadge;